import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/exclusao-de-dados')({
  component: ExclusaoDeDadosPage,
});

// Esta pagina e obrigatoria pela Meta para apps que usam Login do Facebook/Instagram.
// A URL deve ser cadastrada no painel do app em: App Settings > Basic > Data Deletion Request URL
// ou como uma pagina de instrucoes em: App Settings > Basic > Data Deletion Instructions URL

function ExclusaoDeDadosPage() {
  return (
    <div className="min-h-screen bg-page-background p-6 md:p-10">
      <div className="mx-auto max-w-3xl rounded-lg border bg-card p-6 md:p-10">
        <header className="mb-8 space-y-2 border-b pb-6">
          <h1 className="text-3xl font-bold">ASSETO</h1>
          <h2 className="text-xl font-semibold">Exclusao de Dados — Meta (Facebook / Instagram)</h2>
          <p className="text-sm text-muted-foreground">
            Instrucoes para solicitar a exclusao de dados coletados via integracao com plataformas Meta
          </p>
        </header>

        <main className="space-y-8 text-sm leading-7">
          <section className="space-y-3">
            <h3 className="text-lg font-semibold">O que sao os dados coletados via Meta?</h3>
            <p>
              Quando uma empresa utiliza o Asseto com a integracao de canais Meta ativa (Facebook
              Messenger, Instagram ou WhatsApp Business), o Asseto armazena, em nome dessa empresa,
              as mensagens trocadas com seus clientes por meio desses canais.
            </p>
            <p>
              Os dados armazenados incluem: identificadores anonimizados fornecidos pela Meta,
              conteudo de mensagens e metadados (data, hora e tipo de midia).
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">Como solicitar a exclusao</h3>

            <div className="rounded-lg border-l-4 border-primary bg-muted/50 p-4 space-y-2">
              <p className="font-semibold">Opcao 1 — Voce e cliente do Asseto (empresa)</p>
              <p>
                Acesse a plataforma e va em{' '}
                <span className="font-mono bg-muted px-1 rounded">
                  Configuracoes → Omnicanal → Canais Conectados
                </span>{' '}
                e desconecte o canal desejado. Isso revoga o acesso imediatamente.
              </p>
              <p>
                Para solicitar a exclusao permanente de todos os dados armazenados relacionados
                a sua conta Meta, envie um e-mail para{' '}
                <a href="mailto:contato@digitalfluxo.com" className="underline text-primary">
                  contato@digitalfluxo.com
                </a>{' '}
                com o assunto <span className="font-mono bg-muted px-1 rounded">"Exclusao de dados Meta"</span> e
                informe o nome da sua empresa e o canal que deseja excluir (Facebook, Instagram ou WhatsApp).
              </p>
            </div>

            <div className="rounded-lg border-l-4 border-muted-foreground bg-muted/50 p-4 space-y-2">
              <p className="font-semibold">Opcao 2 — Voce e usuario final (pessoa que enviou mensagens para uma empresa)</p>
              <p>
                O Asseto armazena mensagens em nome das empresas que o utilizam. Se voce deseja
                excluir mensagens que enviou para uma empresa especifica, entre em contato
                diretamente com essa empresa.
              </p>
              <p>
                Voce tambem pode revogar o acesso de qualquer aplicativo conectado a sua conta
                Facebook ou Instagram diretamente pelas configuracoes da Meta:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>
                  <a
                    href="https://www.facebook.com/settings?tab=business_tools"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-primary"
                  >
                    Facebook → Configuracoes → Aplicativos e Sites
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/accounts/manage_access/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-primary"
                  >
                    Instagram → Configuracoes → Seguranca → Aplicativos e Sites
                  </a>
                </li>
              </ul>
            </div>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">Prazo de atendimento</h3>
            <p>
              Solicitacoes de exclusao de dados sao atendidas em ate <strong>15 dias uteis</strong>{' '}
              a partir do recebimento da solicitacao. Apos a exclusao, voce recebera uma confirmacao
              por e-mail.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">O que acontece apos a exclusao</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Os tokens de acesso Meta vinculados a sua conta sao invalidados e removidos</li>
              <li>As mensagens armazenadas sao permanentemente excluidas dos nossos servidores</li>
              <li>A integracao com os canais Meta e desativada</li>
              <li>Dados que precisam ser retidos por obrigacao legal (ex: registros fiscais) serao anonimizados</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">Contato</h3>
            <p>
              Para qualquer duvida sobre exclusao de dados, entre em contato com nosso DPO:
            </p>
            <p>
              <a href="mailto:contato@digitalfluxo.com" className="underline text-primary">
                contato@digitalfluxo.com
              </a>
              <br />
              Horario de atendimento: segunda a sexta, das 9h as 18h (horario de Brasilia)
            </p>
          </section>
        </main>

        <footer className="mt-10 border-t pt-6 text-sm text-muted-foreground">
          <div className="flex gap-4">
            <Link to="/politica-privacidade" className="underline">Politica de Privacidade</Link>
            <Link to="/termos-de-uso" className="underline">Termos de Uso</Link>
            <Link to="/politica-cookie" className="underline">Politica de Cookies</Link>
          </div>
        </footer>
      </div>
    </div>
  );
}
